import { memo } from 'react'
import Head from 'next/head'

import appConfig from '~/config/app'

import { FileTopic } from '~/types/theory'

function Tex({
  htmlContent,
  cssUrl,
  h1,
  fullWidth,
}: {
  htmlContent: { html: string }
  cssUrl: string
  h1: string
  fullWidth?: boolean
  topic?: FileTopic
}): React.ReactElement | null {
  const texEnvironment = process.env.NEXT_PUBLIC_TEX_ENVIRONMENT || 'staging'
  const cssHref =
    texEnvironment === 'temp'
      ? `https://storage.googleapis.com/hom-frontend-assets/temp/css/css${cssUrl}`
      : `${appConfig.assetsCdnUrl}/overleaf/${texEnvironment}/css${cssUrl}`

  return (
    <>
      <Head>
        <link href={cssHref} rel="stylesheet" />
      </Head>
      <div
        className={`${fullWidth ? 'w-full' : 'sm:w-full w-4/5'} font-sans font-light sm:text-sm leading-adbox-sm m-0`}
      >
        <header>
          <h1 className="font-bold text-h4 sm:text-h3 leading-normal text-center text-purple">{h1}</h1>
        </header>
        <div
          className="latex-container"
          dangerouslySetInnerHTML={{
            __html: htmlContent.html,
          }}
        />
      </div>
    </>
  )
}

export default memo(Tex)
